export default __webpack_public_path__ + "static/media/paid-check.a46a9d6a.svg";